export class EventTypeMasterData {
  environment: Array<string>;
  schema: Array<string>;
}
